import { createSelector } from 'reselect';
import { selectWhen } from '../selectors';
import { findNestedBlockById } from '../utils/findNestedBlockById';

/**
 * Factory function that creates a memoized selector to extract the blockMeta
 * from the trigger block with a specific ID.
 *
 * @param {string} triggerId - The ID of the trigger block.
 * @param {string} groupId - The ID of the group block.
 * @returns {function(Object): Object|undefined} A selector function that returns blockMeta.
 */
export const makeSelectTriggerBlockMeta = (triggerId, groupId) =>
    createSelector([selectWhen], (when) => {
        const trigger = findNestedBlockById(when, triggerId, groupId);

        return trigger?.blocks?.[0]?.blockMeta;
    });
